import { ITimePickerProps, TimePicker } from '@blueprintjs/datetime';
import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import { css } from 'glamor';

interface DateInputFormFieldProps extends BaseFormFieldProps, ITimePickerProps {}

const centerLabelVerticallyClassName = css({
  '& .bp3-label': {
    alignSelf: 'center',
  },
});

const TimePickerFormField = (props: DateInputFormFieldProps) => {
  const { ...rest } = props;
  return (
    <FormField {...rest} allowNull={true} className={props.inline ? `${centerLabelVerticallyClassName}` : ''}>
      {({ input }) => <TimePicker {...input} inputProps={input} />}
    </FormField>
  );
};

export default TimePickerFormField;
